import { Typography } from "@material-ui/core";
import Intro from "../components/Intro";
import MovieList from "../components/MovieList";
import * as TraktApi from "../api/trakt";
import { useEffect, useState } from "react";
import { useToolbarOptions } from "../context/toolbarOptions";

const HomeScreen = () => {
    const [nowPlayingMovies, setNowPlayingMovies] = useState([]);
    const [mostWatched, setMostWatched] = useState([]);
    const [popularMovies, setPopularMovies] = useState([]);
    const [anticipatedMovies, setAnticipatedMovies] = useState([]);

    const { setToolbarOptions } = useToolbarOptions();
    useEffect(() => {
        setToolbarOptions({ title: "Movie Pal", items: [] });
    }, [setToolbarOptions]);

    useEffect(() => {
        let isSubscribed = true;

        const loadNowPlayingMovies = async () => {
            try {
                const items = await TraktApi.getNowPlayingMovies();
                if (isSubscribed) {
                    setNowPlayingMovies(items);
                }
            } catch (e) {
                console.log(e);
            }
        };
        const loadMostWatchedMoviesThisWeek = async () => {
            try {
                const items = await TraktApi.getMostWatchedMoviesThisWeek();
                if (isSubscribed) {
                    setMostWatched(items);
                }
            } catch (e) {
                console.log(e);
            }
        };
        const loadPopularMovies = async () => {
            try {
                const items = await TraktApi.getPopularMovies();
                if (isSubscribed) {
                    setPopularMovies(items);
                }
            } catch (e) {
                console.log(e);
            }
        };
        const loadAnticipatedMovies = async () => {
            try {
                const items = await TraktApi.getAnticipatedMovies();
                if (isSubscribed) {
                    setAnticipatedMovies(items);
                }
            } catch (e) {
                console.log(e);
            }
        };

        loadNowPlayingMovies();
        loadMostWatchedMoviesThisWeek();
        loadPopularMovies();
        loadAnticipatedMovies();

        return () => (isSubscribed = false);
    }, []);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
            }}
        >
            <Intro />
            <Typography style={{ padding: "5px" }} variant="h6">
                Now Playing
            </Typography>
            <MovieList items={nowPlayingMovies} />
            <Typography style={{ padding: "5px" }} variant="h6">
                Most watched this week
            </Typography>
            <MovieList items={mostWatched} />
            <Typography style={{ padding: "5px" }} variant="h6">
                Popular
            </Typography>
            <MovieList items={popularMovies} />
            <Typography style={{ padding: "5px" }} variant="h6">
                Upcoming
            </Typography>
            <MovieList items={anticipatedMovies} />
        </div>
    );
};

export default HomeScreen;
